module.exports = __webpack_public_path__ + "static/media/8OLA15.b7f275e1.jpg";